import * as React from 'react'
import { ReactElement } from 'react'
import { MailFolder } from '@microsoft/microsoft-graph-types'
import { DataPromise, GraphError } from '../../../context/AxiosContext'
import BaseCombobox, { BaseComboboxProps } from '../BaseCombobox'

export type BaseFolderComboboxProps<D> = Omit<BaseComboboxProps<D>, 'placeholder'> & {
    rootFolderId: DataPromise<string, undefined, GraphError>
    folders: DataPromise<Map<string, MailFolder>, undefined, GraphError>
}

export const getRootFolders = ({ folders, rootFolderId }: Pick<BaseFolderComboboxProps<MailFolder>, 'folders' | 'rootFolderId'>): MailFolder[] =>
    folders.loaded && rootFolderId.loaded ? [...folders.data.values()].filter(folder => folder.parentFolderId === rootFolderId.data) : []

export default function BaseFolderCombobox<D>(props: BaseFolderComboboxProps<D>): ReactElement {
    return (
        <BaseCombobox<D>
            placeholderPrefixKey={''}
            placeholderKey={
                props.folders.loading || props.rootFolderId.loading
                    ? 'base.foldercombobox.placeholder.loading'
                    : 'base.foldercombobox.placeholder.title'
            }
            {...props}
        />
    )
}
